module.exports = __webpack_public_path__ + "static/image26-e85648edaca203e6402b6b558671a630.png";